import { useCallback, useEffect, useState } from 'react';

export type Consent = 'unknown' | 'accepted' | 'rejected';
export const ANALYTICS_CONSENT_KEY = 'consent.analytics';
export const OPEN_COOKIE_SETTINGS_EVENT = 'wealthtimeline:open-cookie-settings';

function readInitial(): Consent {
  try {
    const v = localStorage.getItem(ANALYTICS_CONSENT_KEY) as Consent | null;
    return v === 'accepted' || v === 'rejected' ? v : 'unknown';
  } catch { return 'unknown'; }
}

export function useConsent() {
  const [consent, setConsent] = useState<Consent>(readInitial);

  const updateConsent = useCallback((nextConsent: Consent) => {
    setConsent(nextConsent);
    try {
      localStorage.setItem(ANALYTICS_CONSENT_KEY, nextConsent);
      window.dispatchEvent(new CustomEvent('wealthtimeline:analytics-consent-changed', {
        detail: nextConsent,
      }));
    } catch {
      // Consent still applies for this page even when browser storage is unavailable.
    }
  }, []);

  return { consent, setConsent: updateConsent };
}